import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Slack, Copy } from "lucide-react";

export function SlackBridgeCard() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    api.get("/slack/webhook-info").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);
  if (!info) return null;
  return (
    <div className="card-surface admin-card p-5" data-testid="slack-bridge-card">
      <div className="flex items-center gap-2 mb-2">
        <Slack size={18} className="text-[color:var(--accent)]" />
        <h3 className="text-lg font-bold">Slack bridge</h3>
      </div>
      <p className="text-xs text-slate-500 mb-3">
        Same webhook shape as Discord — point a Slack workflow, bot or middleware at this URL and joins, leaves, messages, and voice minutes flow into your Metrics dashboard alongside Discord.
      </p>
      <div className="flex items-center gap-2">
        <code className="flex-1 text-[11px] break-all bg-[#0b0d12] border border-[#2a3447] rounded px-2 py-1.5 text-slate-300" data-testid="slack-webhook-url">{info.url}</code>
        <button
          type="button"
          onClick={() => { navigator.clipboard.writeText(info.url); toast.success("Copied"); }}
          className="text-slate-400 hover:text-[color:var(--accent)]"
          title="Copy"
        >
          <Copy size={14} />
        </button>
      </div>
      <div className="text-[11px] text-slate-500 mt-2">
        Example payload: <code className="text-slate-300">{JSON.stringify(info.example_payload)}</code>
      </div>
    </div>
  );
}

export default SlackBridgeCard;
